import type { FaireProductEntity } from "../../entity_types/product";

export const p_ff5z59dch8: FaireProductEntity = {
  token: "p_ff5z59dch8",
  type: "product",
  name: "Striped Elevated Ceramic Pet Bowl for Cats & Dogs_CWMM5948",
  brandToken: "b_g84ckd3mt5",
  brandName: "PAWPAWwholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/3c18209c69729875d664aead41b85fbbc73a0beef7fc5ada287320e21b7dcbee.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/81ee2498ca05c567dcf9e4c7415567421357e45244e72b6a9bf8c87fcf645708.jpeg",
    "https://cdn.faire.com/fastly/11d156e21a7d0c9be2becd201268b39c6838b02ee9a33ce0b641df7f5332fb7b.jpeg",
    "https://cdn.faire.com/fastly/db299a85e21b2b736a35edd28559d9a5ca2e14c505c6ee7cbcd359a296099b03.jpeg",
    "https://cdn.faire.com/fastly/64131f58905dc8512ba57dca90bbec8a96263429779bb5de918d7ba7fd41ef1e.jpeg",
    "https://cdn.faire.com/fastly/2395fc1e979f15abadb8e988fb962815510896403c6083c8e3416996d1966b37.jpeg",
    "https://cdn.faire.com/fastly/a052e6419f48397548ce0665f168425cc50f8412bb0affd3629d757de85c5a1d.jpeg",
    "https://cdn.faire.com/fastly/850524e711d27f117670753c91b8c46435e469821c5f4cb305f99e91c74b1f5a.jpeg",
    "https://cdn.faire.com/fastly/6c6272f78a13fa584331325a1ffbc07328da178073f89bce343a10246ef7b5fa.jpeg",
  ],
  priceDollars: 21.41,
  description:
    "-Product Type: High-Footed Pet Bowl\n-Material: 100% Ceramic\n-Size: See pictures\n\nTypes of products that will be on the shelves during this period:\nPet bowl,Dog bowl,Cat bowl,Pet feeder,Food bowl,Water bowl,Drinking bowl,Food and water set,Non-slip base,Non-skid bottom,Elevated dog bowl,Raised pet feeder,Slow feeder bowl,Anti-choke design,Spill-proof, Splash-proof water bowl,Collapsible bowl,Travel dog bowl,Double bowl set,Dual bowl,Automatic pet feeder,Self-watering bowl,Gravity waterer,Stainless steel pet bowl,Ceramic dog bowl / Handmade ceramic bowl,BPA-free plastic bowl,Silicone collapsible bowl,Bamboo pet feeder,Wood stand,Eco-friendly,Sustainable materials,Minimalist pet bowl,Modern dog bowl,Cute cat bowl,Personalized pet bowl, Custom name bowl,Pastel color pet dish,Wooden stand pet bowl,Boho pet bowl,Small dog bowl / For puppies,Large dog bowl / For big dogs,For cats,For kittens,Fits Frenchie,Pug,Golden Retriever,XL dog bowl,Deep bowl for large breeds,Travel pet bowl,On-the-go.",
  tags: [],
  msrpDollars: 33.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:54.365Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
